import { render } from "./Erro.vue?vue&type=template&id=38f34aa7"
const script = {}
script.render = render

export default script